// extracted by mini-css-extract-plugin
module.exports = {"articleSvg":"t5HtQ","example":"_3XcZG","videoSvg":"_1Qnez"};